import React from "react";

type Props = {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
  onBack?: () => void;
};

export function PageHeader({ title, subtitle, right, onBack }: Props): React.JSX.Element {
  return (
    <div className="bg-white border-b border-ink-100 px-4 shrink-0 min-h-[52px] flex items-center gap-2.5">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Volver"
          className="text-[22px] text-ink-500 leading-none p-1 shrink-0 cursor-pointer"
        >
          ‹
        </button>
      )}
      <div className="flex-1 min-w-0 py-2.5">
        <div className="font-display font-extrabold text-[22px] text-ink-900 leading-none">
          {title}
        </div>
        {subtitle && (
          <div className="text-[11px] text-ink-500 mt-0.5">{subtitle}</div>
        )}
      </div>
      {right && <div className="shrink-0 flex items-center gap-2">{right}</div>}
    </div>
  );
}
